import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Notification, { NOTIFICATION_TYPE } from 'components/common/notification';
import COLORS from 'styles/colors.scss';
import { formatCopy } from 'utils/typography';

const STORAGE_KEY = 'vedmarket.calculator.disclaimer.dismissed';

const CalculatorDisclaimer = () => {
  const { t } = useTranslation();

  const [ isVisible, setIsVisible ] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) !== 'true';
    } catch {
      return true;
    }
  });

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {
      // Keep dismissal available when browser storage is restricted.
    }

    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Notification
      type={NOTIFICATION_TYPE.WARNING}
      title={formatCopy(t('common__message__warning'))}
      noCloseButton
      sx={{ marginBottom: 3 }}
      text={(
        <>
          <Typography variant='body2' color='inherit'>
            {formatCopy(t('calc__text__disclaimer'))}
          </Typography>
          <Button
            color='inherit'
            variant='outlined'
            onClick={handleDismiss}
            style={{ borderColor: COLORS.WHITE }}
            sx={{
              marginTop: 2,
              color: COLORS.WHITE,
            }}
          >
            <Typography component='span' variant='inherit' color='inherit'>
              {formatCopy(t('calc__actions__dismissDisclaimer'))}
            </Typography>
          </Button>
        </>
      )}
    />
  );
};

export default CalculatorDisclaimer;
